import { useEffect, useState } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { asyncWithLDProvider, LDEvaluationDetail } from 'launchdarkly-react-client-sdk';
import { CenteredProgress } from '../../components';
import { decodeTokens, getAppConfig, getAuthInfo } from '../../utils';
let LDProviderTest: any;

interface propsChildren {
  children: JSX.Element;
}
const LaunchDarklyFeatureFlagInit = ({ children }: propsChildren) => {
  const { xbsEnvironment, launchDarklyEnv } = getAppConfig();
  const [isProviderReady, setConfigurationLoaded] = useState(false);
  const { authToken } = getAuthInfo();
  const userData = decodeTokens(authToken);

  useEffect(() => {
    if (!isProviderReady) {
      (async () => {
        LDProviderTest = await asyncWithLDProvider({
          clientSideID: launchDarklyEnv[xbsEnvironment],
          user: {
            key: userData?.userId,
            email: '',
            name: ''
          },
          options: {
            inspectors: [
              {
                type: 'flag-used',
                name: 'dd-inspector',
                method: (key: string, detail: LDEvaluationDetail) => {
                  // Integrate feature flag evaluations with Datadog
                  datadogRum.addFeatureFlagEvaluation(key, detail.value);
                }
              }
            ]
          }
        });
        setConfigurationLoaded(true);
      })();
    }
  }, [isProviderReady, xbsEnvironment, launchDarklyEnv, userData?.userId]);
  return isProviderReady ? <LDProviderTest>{children}</LDProviderTest> : <CenteredProgress />;
};

export default LaunchDarklyFeatureFlagInit;
